<div *ngIf="isOpen" class="full-spinner">
    <div [ngStyle]="{'background': bg}"
         class="progress-spinner">
        <span class="progress-spinner-text">
           {{ progress + '%' }}
        </span>
    </div>
</div>

